import { MAP_TOOLS } from '../../../lib/constants';

export default (dispatch) => ({
  enableElevationProfile: () => {
    dispatch({
      type: 'map/resetWidgetState',
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.ElevationProfile,
    });
  },

  setElevProfWidgetRef: (ref) => {
    dispatch({
      type: 'map/setElevProfWidgetRef',
      payload: ref
    });
  },

  clearMeasurements: () => {
    dispatch({
      type: 'map/resetWidgetState',
    });
  }
});